import { ILegalCheckState } from '../../types/legalCheck';
import { TReduxActions } from '../../types/redux';
import { ELegalCheckActions } from '../../constants/actionTypes/legalCheck';

export const defaultState: ILegalCheckState = {};
export const legalCheckReducer = (state: ILegalCheckState = defaultState, action: TReduxActions): ILegalCheckState => {
  switch (action.type) {
    case ELegalCheckActions.SET_LEGAL_ID:
      return {
        ...state,
        id: action.payload,
      };
    case ELegalCheckActions.SET_IS_REGISTERED:
      return {
        ...state,
        isRegistered: action.payload,
      };
    case ELegalCheckActions.SET_PRICE:
      return {
        ...state,
        price: action.payload,
      };
    case ELegalCheckActions.SET_AGREEMENT_OFFER:
      return {
        ...state,
        agreementOffer: action.payload,
      };
    case ELegalCheckActions.SET_AGREEMENT_PERSONAL:
      return {
        ...state,
        agreementPersonal: action.payload,
      };
    case ELegalCheckActions.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    default:
      return state;
  }
};
